(() => {
  const stateCache = new WeakMap();

  document.addEventListener(
    "change",
    (event) => {
      const input = event.target.closest(
        'product-card input[type="radio"][data-option-position][data-option-value-name]'
      );

      if (!input) {
        return;
      }

      const productCard = input.closest("product-card");
      const stateElement = productCard?.querySelector("[data-product-card-variant-state]");

      if (!stateElement) {
        return;
      }

      let state = stateCache.get(productCard);

      if (!state) {
        state = JSON.parse(stateElement.textContent);
        stateCache.set(productCard, state);
      }

      const optionPosition = Number(input.dataset.optionPosition) - 1;
      state.selectedOptions[optionPosition] = input.dataset.optionValueName;

      const variant = state.variants.find((candidate) =>
        candidate.options.every((value, index) => value === state.selectedOptions[index])
      );

      if (!variant) {
        return;
      }

      input.dataset.variantId = String(variant.id);
      input.dataset.variantSku = variant.sku || "";

      if (variant.media) {
        input.dataset.variantMedia = JSON.stringify(variant.media);
      } else {
        delete input.dataset.variantMedia;
      }

      if (variant.secondaryMedia) {
        input.dataset.variantSecondaryMedia = JSON.stringify(variant.secondaryMedia);
      } else {
        delete input.dataset.variantSecondaryMedia;
      }

      const skuElement = productCard.querySelector("[data-product-card-sku]");

      if (skuElement) {
        skuElement.textContent = variant.sku || "";
      }
    },
    true
  );
})();
